import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ToastsManager } from 'ng2-toastr';
import { AuthService } from '../../../services/auth.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';

@Component({
  selector: 'app-change-password-form',
  templateUrl: './change-password-form.component.html',
  styleUrls: ['./change-password-form.component.scss']
})
export class ChangePasswordFormComponent implements OnInit {
  @Output() isPasswordChagned: EventEmitter<boolean> = new EventEmitter<boolean>();

  public changePasswordForm: FormGroup;
  public hideNewPassword = true;
  public hideOldPassword = true;
  public validationMessage: string;
  isSubmitting = false;

  private passwordRegex: RegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!*()@%&]).{10,}$/;

  constructor(
    private authService: AuthService,
    private toastr: ToastsManager,
    private recaptchaV3Service: ReCaptchaV3Service
  ) {}

  ngOnInit(): void {
    this.createChangePasswordForm();
    this.changePasswordForm.markAsTouched();
  }

  createChangePasswordForm(): void {
    this.changePasswordForm = new FormGroup(
      {
        username: new FormControl('', Validators.required),
        oldPassword: new FormControl('', Validators.required),
        newPassword: new FormControl(
          '',
          Validators.compose([Validators.required, Validators.pattern(this.passwordRegex)])
        )
      },
      {
        validators: [this.verifyPassword()]
      }
    );
  }

  verifyPassword(): ValidatorFn {
    return (formGroup: FormGroup): ValidationErrors | null => {
      const oldPassword = formGroup.controls['oldPassword'];
      const newPassword = formGroup.controls['newPassword'];
      if (newPassword.value !== '') {
        formGroup.get('newPassword').markAsTouched();
      }
      if (newPassword.errors && !newPassword.errors.passwordNotMatch) {
        return null;
      }
      if (oldPassword.value === newPassword.value) {
        newPassword.setErrors({ passwordNotMatch: true });
        return { passwordNotMatch: true };
      } else {
        newPassword.setErrors(null);
        return null;
      }
    };
  }

  changePassword(form: FormGroup): void {
    this.validationMessage = null;

    if (!form.valid) {
      return;
    }

    this.isSubmitting = true;

    this.recaptchaV3Service.execute('importantAction').subscribe(recaptchaToken => {
      const changePasswordDto = form.getRawValue();
      changePasswordDto.recaptchaToken = recaptchaToken;
      this.authService.changePasswordByUsername(changePasswordDto).subscribe(
        res => {
          this.changePasswordForm.reset();
          this.isPasswordChagned.emit(true);
          this.toastr.success('Hasło zostało zmienione!');
          this.isSubmitting = false;
        },
        err => {
          this.isSubmitting = false;

          if (err.status === 405) {
            this.validationMessage = 'Konto jest zablokowane. Skontaktuj się z administratorem.';
          } else if (err.status === 403) {
            this.toastr.error('Błędny login lub hasło!');
          } else if (err.status === 400) {
            this.validationMessage = null;
            this.toastr.error('Weryfikacja tokenu captcha nie powiodła się!');
          }
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/auth/change-password-form/change-password-form.component.ts